import {initWebComponent} from "@/helpers/web-component-helper";
import {OlComponent} from "@/components/ol/ol-component";
import {getWizard} from "@/http/services/http-services-wizard";
import {WizardNavComponent} from "@/components/wizard/wizard-nav-component";
import {WizardTabComponent} from "@/components/wizard/wizard-tab-component";
import {WizardSendMessageComponent} from "@/components/wizard/wizard-send-message-component";
import {initSmartWizard} from "@/helpers/smart-wizard-helper";
import $ from "jquery";

const template = document.createElement('template');

export class WizardComponent extends HTMLElement {
    constructor() {
        super();

        getWizard().then((wizard) => {

            window.cbsCodes = wizard.settings.GemeenteCode

            window.wizard = wizard

            document.querySelectorAll('layout-top-nav-bar-item')[1].querySelector('a').innerHTML = wizard.guidelines.headlineTitle
            document.querySelectorAll('layout-top-nav-bar-item')[3].querySelector('a').innerHTML = wizard.guidelines.headlineTitle

            template.innerHTML = `

            <div class="container-fluid container-body">
                <div class="row">
                    <div class="col-12">
                        <div class="d-none d-md-block">
                            <h1 class="text-primary">` + wizard.Presentation.DisplayName + `</h1>
                        </div>
                        <div id="smartwizard">
                            <wizard-send-message class="d-none"></wizard-send-message>
                            <wizard-nav></wizard-nav>
                            <wizard-tab></wizard-tab>
                        </div>
                    </div>
                </div>
            </div>
            `;

            initWebComponent(this, template)

            $('.layout-content').append('<page-guidelines class="layout-page d-none"></page-guidelines>')


            initSmartWizard()

        })
    }
}

window.customElements.define("ol-map", OlComponent);
window.customElements.define("wizard-nav", WizardNavComponent);
window.customElements.define("wizard-tab", WizardTabComponent);
window.customElements.define("wizard-send-message", WizardSendMessageComponent);
